export const prepareBaselineTasks = baselineData => {
  return baselineData.tasks.map(task => {
    task.status = (baselineData.customValues[task.id] && baselineData.customValues[task.id].status) || baselineData.defaultCustomValues.status;
    task.priority = (baselineData.customValues[task.id] && baselineData.customValues[task.id].priority) || baselineData.defaultCustomValues.priority;
    task.jira_key = (baselineData.customValues[task.id] && baselineData.customValues[task.id].jira_key) || '';
    task.resources = baselineData.resourcesToTasks[task.id] || [];

    return task;
  })
}
